let customOrder = require('../../../actions/custom-order');
let cities = require('../../../actions/custom-order/cities');
let branches = require('../../../actions/custom-order/branches');
let rubrics = require('../../../actions/custom-order/rubrics');
let purposes = require('../../../actions/custom-order/purposes');
let mapClasses = require('../../../actions/custom-order/map-classes');
let paymentTypes = require('../../../actions/custom-order/payment-types');
let numberOfEmployees = require('../../../actions/custom-order/number-of-employees');
let filials = require('../../../actions/custom-order/filials');
let legalEntities = require('../../../actions/custom-order/legalEntities');
let addParams = require('../../../actions/custom-order/additional-parameters');
let error = require('../../../actions/error');
let utils = require('../../../actions/utils');

let setOrderParametersGroup = [
    customOrder.setAvailableParameters,
    cities.initTreeState,
    cities.initMapFilter,
    branches.initTreeState,
    rubrics.initTreeState,
    legalEntities.initTreeState,
    purposes.initTreeState,
    mapClasses.initTreeState,
    paymentTypes.initTreeState,
    numberOfEmployees.initTreeState,
    addParams.initExportColumnsState,
    addParams.initGreederColumns,
    filials.initOptions
];

let defaultToBranches = [
    utils.setArg('value', false),
    branches.setAll,
    utils.setArg('value', true),
    cities.getBranchesTreeFilter,
    branches.setSelection
];

module.exports = {
    setOrderParametersGroup,

    getAvailableParametersGroup: [
        [
            customOrder.getAvailableParameters,
            {
                success: [
                    ...setOrderParametersGroup
                ],
                error: [
                    error.internalError('customOrder.getAvailableParameters')
                ]
            }
        ]
    ],

    defaultToBranches,

    // если менеджер находится на вкладке "По проектам", а тип заказа "Оффлайн", то надо отобразить города на проекты
    // потому что бекенд для заказов типа "Оффлайн" преобразует проекты в города
    // если есть желание от этого избавится, то нужно будет в restoreState сбрасывать выбранную вкладку ['order', 'cities', 'tab']
    restoreStateGroup: [
        customOrder.restoreState,
        [
            customOrder.isTabSelected('branches'),
            {
                yes: [
                    [
                        utils.isEqual(['account', 'orders', 'currentOrder', 'typeId'], 2),
                        {
                            yes: [...defaultToBranches],
                            no: []
                        }
                    ]
                ],
                no: []
            }
        ]
    ]
};



// WEBPACK FOOTER //
// ./signals/groups/custom-order/index.js